<template>
  <div
    class="team-card row align-center rounded tournament-blue-outline tournament-light-blue px-4 elevate-3d elevate-3"
  >
    <!-- Team name -->
    <div
      v-if="team.name"
      class="column tournament-white--text flex pl-2 mr-2 ellipsis"
    >
      <span class="caption translucid">Nome da equipe</span>
      <div class="row align-center title ellipsis" style="height: 36px">
        {{ team.name }}
      </div>
    </div>

    <!-- Team number -->
    <div
      v-if="team.alias && !$vuetify.breakpoint.xsOnly"
      class="column tournament-white--text pr-2"
      style="width: 126px"
    >
      <span class="caption translucid">Número da equipe</span>
      <div class="row bold align-center subdisplay" style="height: 36px">
        #{{ team.alias }}
      </div>
    </div>

    <div v-if="arrow" class="column align-end" style="width: 36px">
      <v-icon color="tournament-grey" style="font-size: 36px">
        keyboard_arrow_right
      </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamCard",
  props: {
    team: {
      type: Object,
      required: true,
    },
    arrow: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.team-card {
  height: 120px;
  border-left: 10px solid;
}
.team-card.dense {
  height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/Teams/Card/index.vue